module.exports = __webpack_public_path__ + "media/bootstrap-icons/exclamation-circle-fill-5f3e6da7.svg";